<template>
  <div class="periodical-proximity-container">
    <SpinnerContainer v-if="$store.state.appConfig.isLoading"/>
    <template v-else>
      <div class="back-container">
        <BackButton :clickMethod="closePage" class="mb-3"/>
      </div>

      <div v-if="dataSample" class="proximity-container cs-scroll-style">
        <div class="proximity-container-header">
          <div class="image-container">
            <b-img  class="mx-auto detail-image" :src="dataSample.logoUrl" />
          </div>
          <div>
            <h4>{{ $tPop(dataSample.sourceCode, 'title',  dataSample.title) }} </h4>
          </div>
        </div>
        <div class="proximity-container-item" v-if="dataSample.videoUrl">
          <VideoContainer :videoSrc="dataSample.videoUrl"/>
        </div>
        <div class="proximity-container-item">
          <h5>{{ $tI('Sub-population title') }}</h5>
          <hr/>
          <div class="pop-view">
            <div class="pop-view-item" v-for="regionItem in subResults" :key="regionItem.resultName">
              <h6>{{ $t(regionItem.resultSubTitle.replaceAll('*', ' ')) }}</h6>
              <div class="d-flex align-items-center lab-p-8">
                <span class="mr-75 percent-txt"><b>{{ regionItem.resultValue.toFixed(1) }}%</b></span>
                <vue-apex-charts
                  type="radialBar"
                  height="40"
                  width="40"
                  :options="onGetChartOption(dataSample.color)"
                  :series="[regionItem.resultValue.toFixed(1)]"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="proximity-container-item">
          <h5>{{ $tI('Description title') }}</h5>
          <hr/>
          <div>
            <p class="description" v-html="formattedDescription"></p>
          </div>
        </div>

        <div class="proximity-container-item">
          <h5>{{ $tI('Reference Samples title') }}</h5>
          <hr/>
          <div>
            <p class="description" v-html="dataSample.referenceSamples"></p>
          </div>
        </div>

        <div class="proximity-container-item">
          <h5>{{ $tI('Research Links title') }}</h5>
          <hr/>
          <ResearchLink :researchLinkContent="dataSample.researchLinks"/>
        </div>
      </div>
    </template>    
  </div>
</template>

<script>
import BackButton from '@/components/ui/BackButton.vue';
import VueApexCharts from 'vue-apexcharts'
import VideoContainer from '@/components/ui/VideoContainer.vue';

export default {
  components: {
    BackButton,
    VueApexCharts,
    VideoContainer,
  },
  data() {
    return {
      subResults: [],
    };
  },
  methods: {
    fetchDetail() {
      this.subResults = [];
      const originalResults = this.$store.getters['periodicalResult/getOriginalResults'];
      if (originalResults.resultList) {
        let filterResults = originalResults.resultList.filter(x => x.resultName.includes(this.dataSample.sourceCode));
        filterResults = filterResults.map(item => {
          if (item.resultName.includes(':')) {
            item.resultSubTitle = item.resultName.split(':')[1];
          } else {
            item.resultSubTitle = item.resultName;
          }
          return item;
        });

        this.subResults = JSON.parse(JSON.stringify(filterResults)).reduce((list, item) => {
          let findItem = list.find(x => x.resultSubTitle === item.resultSubTitle);
          if (findItem) {
            findItem.resultValue += item.resultValue;
          } else {
            list.push(item);
          }
          return list;
        }, []);
      }
    },

    onGetChartOption(color) {
      /* eslint-disable */
      const barColor = color ? color : '#00ADB5';
      return {
        grid: {
          show: false,
          padding: {
            left: -15,
            right: -15,
            top: -12,
            bottom: -15,
          },
        },
        colors: [barColor],
        plotOptions: {
          radialBar: {
            hollow: {
              size: '22%',
            },
            track: {
              background: this.ddAlpha(color, 0.1),
            },
            dataLabels: {
              showOn: 'always',
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
        stroke: {
          lineCap: 'round',
        },
      };
    },
    ddAlpha(color, opacity) {
      let _opacity = Math.round(Math.min(Math.max(opacity ?? 1, 0), 1) * 255);
      return color + _opacity.toString(16).toUpperCase();
    },

    closePage() {
      this.$store.state.periodicalResult.openedPeriodicalDetail = { id: 0, };
      this.$store.state.periodicalResult.isOpenedPeriodicalDetail = true;
    },
  },
  computed: {
    dataSample() {
      return this.$store.state.periodicalResult.openedPeriodicalDetail;
    },
    formattedDescription() {
      const description = this.$tPop(this.dataSample.sourceCode, 'description',  this.dataSample.description);
      return description ? description.replace(/\n/g, '<br>') : '';
    }
  },
  mounted() {
    this.fetchDetail();
  }
};
</script>

<style lang="scss" scoped>
.periodical-proximity-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: var(--white-100);

  .proximity-container {
    padding: 0 28px 28px 28px;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .proximity-container-header {
    display: flex;
    align-items: center;
    justify-content: start;
    background-color: var(--bg-body-color);
    border-radius: 10px;
    .image-container {
      display: block;
      padding: 1rem 0.5rem;
      border-radius: 10px;

      img {
        height: 120px !important;
        width: 120px !important;
        border-radius: 10px;
      }
    }
  }

  .breakdown-item {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .value-text {
      display: flex;
      align-items: center;
    }
  }

  .proximity-container-item {
    .pop-view-item {
      cursor: text;
    }
    .pop-view-item:hover {
      transform: none;
    }
  }
}

</style>